import type { FC } from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { ContainerResource } from 'api/generated';
import { volumeFormatter as formatNumber} from "services/utils/formatterUtil";

interface Props {
  containersSaved: ContainerResource[];
}

const columns: ColumnsType<ContainerResource> = [
  {
    title: 'Clave de identificación',
    dataIndex: 'containerKey',
  },
  {
    title: 'Capacidad total',
    dataIndex: 'containerTotalCapacity',
    render: (text: number, record) => {
      const udm = record.product?.measurementUnit?.measurementDescription ?? '';
      return <span>{`${formatNumber(text)} ${udm}`}</span>;
    },
  },
  {
    title: 'Tipo de producto',
    key: 'productDescription',
    render: (_, record) => record.product?.productDescription,
  },
  {
    title: 'Tipo de subproducto',
    key: 'subproductDescription',
    render: (_, record) => record.subproduct?.description,
  },
];

const FirstListContainersSaved: FC<Props> = ({
  containersSaved,
}) => (
  <Table<ContainerResource>
    rowKey={(record) => record.idContainer ?? ''}
    dataSource={containersSaved}
    columns={columns}
    pagination={false}
  />
);

export default FirstListContainersSaved;